const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://cdv8v1esna.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://6r3xd4ymr4.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.3',
    HOSTNAME: 'https://company.testing.saas.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.testing.saas.forwoodsafety.com',
    WEBSOCKET: 'wss://rs4k9t9nml.execute-api.us-west-2.amazonaws.com/testing'
  },
};

export default config;